module.exports = __webpack_public_path__ + "static/excited.6fe7041a.jpg";